import { useState } from 'react';

import { Button, Divider, Grid, Typography } from '@mui/material';
import { DotsThreeVertical, X } from 'phosphor-react';

import { createFadeSlideAnimation } from '~components/theme/styles/animations';
import { black, primaryColors, secondaryColors } from '~components/theme/styles/colors';
import { hideScrollbar } from '~components/theme/styles/mixins';

import { ImageVestaLogoV2 } from '../../ui/images';
import { SideBarList } from '../sidebar';

import { MobileAccountPanel } from './MobileAccountPanel';

export const MOBILE_NAV_HEIGHT = '88px';

export const MobileNavBar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<'sidebar' | 'dial'>('sidebar');

  let openContent = null;

  if (mode === 'sidebar') {
    openContent = (
      <Grid container>
        <SideBarList
          width="100%"
          onClick={() => {
            setIsOpen(false);
          }}
        />
      </Grid>
    );
  } else if (mode === 'dial') {
    openContent = <MobileAccountPanel setIsOpen={setIsOpen} />;
  }

  return (
    <Grid
      sx={{
        ...hideScrollbar,
        width: '100vw',
        height: isOpen ? '100vh' : 'initial',
        position: 'fixed',
        zIndex: 1000,
        background: isOpen
          ? mode === 'dial'
            ? 'linear-gradient(47.42deg, #171717 49.75%, rgba(23, 23, 23, 0) 77.72%), #262626'
            : black['85%']
          : black['15%'],
        backdropFilter: 'blur(15px)',
        animation: createFadeSlideAnimation(0),
      }}
    >
      <Grid sx={{ p: '32px' }}>
        <Grid container sx={{ px: '16px 0', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button
            onClick={() => {
              setIsOpen(prev => !prev);
              setMode('dial');
            }}
            sx={{ minWidth: 0, padding: 0 }}
          >
            <ImageVestaLogoV2 height={28} width={28} background={secondaryColors[200]} />
          </Button>

          <Typography
            variant="h6"
            sx={{
              color: primaryColors[700],
              display: 'flex',
              gap: '1em',
              justifyContent: 'space-around',
              textAlign: 'center',
            }}
          >
            <span>V</span>
            <span>E</span>
            <span>S</span>
            <span>T</span>
            <span>A</span>
          </Typography>
          <Button
            onClick={() => {
              setIsOpen(prev => !prev);
              setMode('sidebar');
            }}
            sx={{ minWidth: 0, padding: 0 }}
          >
            {!isOpen ? <DotsThreeVertical size={28} /> : <X size={28} />}
          </Button>
        </Grid>
      </Grid>
      {isOpen ? (
        <>
          <Divider sx={{ margin: 0 }} />
          <Grid container>{openContent}</Grid>
        </>
      ) : undefined}
    </Grid>
  );
};
